import React, { Component } from 'react';
import Utils from '../../../../common/utils/Utils';
import EventStatistics from './EventStatistics';
import { getEventStatisticsData } from './EventStatistics.actions';
import {
  withRouter,
  getQueryParam,
  setQueryParam,
} from '../../../../common/utils/NavigationWrapper';
import moment from 'moment';
import Constants from '../../../../common/constants/Constants';

const viewMode = [{ name: 'by day' }, { name: 'by assay' }];

const defaultState = (props) => ({
  isFetching: false,
  dateFromFilter: Utils.NowAsUtcFe().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
  dateToFilter: Utils.NowAsUtcFe()
    .add(1, 'days')
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
  selectedEventCategoryFilter: props.selectedEventCategory,
  selectedViewModeFilter: props.selectedViewMode,
  selectedAssayFilter: 'All assays',
  tableConfig: [],
  tableData: [],
  assayFilter: [],
  isDayViewMode: props.selectedViewMode.name === 'by day' ? true : false,
  metadata: {},
  dateTimeErrorMessage: null,
});

class EventStatisticsContainer extends Component {
  static defaultProps = {
    dateFrom: null,
    dateTo: null,
    eventCategory: null,
    viewMode: null,
    assayFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = defaultState(props);

    this._onApplyFilters = this._onApplyFilters.bind(this);
    this._onChangeDropDownSelection = this._onChangeDropDownSelection.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.selectedEventCategory != null &&
      newProps.selectedEventCategory.displayName !== this.props.selectedEventCategory.displayName
    ) {
      const [dateFrom, dateTo, eventCategory, viewMode, selectedAssay] =
        this._getQueryValues(newProps);

      const newDateTo = this._determinePropertyValue(dateFrom, 'dateFromFilter');
      const newDateFrom = this._determinePropertyValue(dateTo, 'dateToFilter');
      const dateTimeErrorMessage = this._checkDateTimeCorrectness(newDateFrom, newDateTo);
      let newState = {
        ...defaultState(newProps),
        selectedEventCategoryFilter: eventCategory
          ? this._determinePropertyValue(eventCategory, 'selectedEventCategoryFilter')
          : newProps.selectedEventCategory,
        dateFromFilter: newDateFrom,
        dateToFilter: newDateTo,
        selectedViewModeFilter: this._determinePropertyValue(viewMode, 'selectedViewModeFilter'),
        selectedAssayFilter: this._determinePropertyValue(selectedAssay, 'selectedAssayFilter'),
        isDayViewMode: this._determinePropertyValue(viewMode, 'isDayViewMode'),
        dateTimeErrorMessage,
      };
      this.setState(() => newState);
    }
  }

  componentDidMount() {
    const [dateFrom, dateTo, eventCategory, viewMode, selectedAssay] = this._getQueryValues(
      this.props
    );

    const newDateFrom = this._determinePropertyValue(dateFrom, 'dateFromFilter');
    const newDateTo = this._determinePropertyValue(dateTo, 'dateToFilter');
    const dateTimeErrorMessage = this._checkDateTimeCorrectness(newDateFrom, newDateTo);
    this.setState(
      {
        selectedEventCategoryFilter: this._determinePropertyValue(
          eventCategory,
          'selectedEventCategoryFilter'
        ),
        dateFromFilter: newDateFrom,
        dateToFilter: newDateTo,
        selectedViewModeFilter: this._determinePropertyValue(viewMode, 'selectedViewModeFilter'),
        selectedAssayFilter: this._determinePropertyValue(selectedAssay, 'selectedAssayFilter'),
        isDayViewMode: this._determinePropertyValue(viewMode, 'isDayViewMode'),
        dateTimeErrorMessage,
      },
      () => {
        this._onApplyFilters();
      }
    );
  }

  render() {
    return (
      <EventStatistics
        dateFromFilter={this.state.dateFromFilter}
        dateToFilter={this.state.dateToFilter}
        isFetching={this.state.isFetching}
        selectedEventCategoryFilter={this.state.selectedEventCategoryFilter}
        selectedViewModeFilter={this.state.selectedViewModeFilter}
        selectedAssayFilter={this.state.selectedAssayFilter}
        tableData={this.state.tableData}
        tableConfig={this.state.tableConfig}
        eventCategories={this.props.reports}
        viewMode={viewMode}
        instrument={this.props.instrument}
        assayFilter={this.state.assayFilter}
        onChangeDate={this._onChangeDate}
        onChangeDropDownSelection={this._onChangeDropDownSelection}
        onApplyFilters={this._onApplyFilters}
        isDayViewMode={this.state.isDayViewMode}
        metadata={this.state.metadata}
        dateTimeErrorMessage={this.state.dateTimeErrorMessage}
      />
    );
  }

  _getQueryValues = (props) => {
    const dateFrom = getQueryParam('dateFrom', 'customDateTimeType', props.querySearchParams);
    const dateTo = getQueryParam('dateTo', 'customDateTimeType', props.querySearchParams);
    const eventCategory = getQueryParam('eventCategory', 'string', props.querySearchParams);
    const viewMode = getQueryParam('viewMode', 'string', props.querySearchParams);
    const selectedAssay = getQueryParam('selectedAssay', 'string', props.querySearchParams);

    return [dateFrom, dateTo, eventCategory, viewMode, selectedAssay];
  };

  _determinePropertyValue = (propertyValue, propertyNameInState) => {
    if (propertyValue == null) {
      return this.state[propertyNameInState];
    }

    switch (propertyNameInState) {
      case 'selectedEventCategoryFilter': {
        return this._getEventCategoryByName(propertyValue);
      }
      case 'selectedViewModeFilter': {
        return this._getViewModeByName(propertyValue);
      }
      case 'isDayViewMode': {
        return propertyValue === 'by day' ? true : false;
      }
      default: {
        return propertyValue;
      }
    }
  };

  _getEventCategoryByName = (name) => {
    return this.props.reports.find((e) => {
      return e.displayName === name;
    });
  };

  _getViewModeByName = (name) => {
    return viewMode.find((e) => {
      return e.name === name;
    });
  };

  _onChangeDate = (type, newDate) => {
    let dateTimeErrorMessage = null,
      newDateFrom = null,
      newDateTo = null;

    switch (type) {
      case 'dateFromFilter': {
        newDateFrom = newDate;
        newDateTo = this.state.dateToFilter;
        break;
      }
      case 'dateToFilter': {
        newDateFrom = this.state.dateFromFilter;
        newDateTo = newDate;
        break;
      }
      default:
        break;
    }

    dateTimeErrorMessage = this._checkDateTimeCorrectness(newDateFrom, newDateTo);

    this.setState(
      { dateFromFilter: newDateFrom, dateToFilter: newDateTo, dateTimeErrorMessage },
      () => {
        let newQueryParams = [
          {
            value: newDateFrom,
            key: 'dateFrom',
            type: 'customDateTimeType',
          },
          {
            value: newDateTo,
            key: 'dateTo',
            type: 'customDateTimeType',
          },
        ];

        setQueryParam(
          newQueryParams,
          this.props.querySearchParams,
          this.props.setQuerySearchParams
        );
      }
    );
  };

  _onChangeDropDownSelection = (type, index) => {
    switch (type) {
      case 'selectedEventCategoryFilter': {
        const newValue = this.props.reports[index];
        this.setState({ selectedEventCategoryFilter: newValue }, () => {
          setQueryParam(
            [
              {
                value: this.state.selectedEventCategoryFilter.displayName,
                key: 'eventCategory',
                type: 'string',
              },
            ],
            this.props.querySearchParams,
            this.props.setQuerySearchParams
          );
        });
        break;
      }
      case 'selectedViewModeFilter': {
        const newValue = viewMode[index];
        const isDayViewMode = newValue.name === 'by day' ? true : false;
        this.setState({ selectedViewModeFilter: newValue, isDayViewMode }, () => {
          setQueryParam(
            [
              {
                value: this.state.selectedViewModeFilter.name,
                key: 'viewMode',
                type: 'string',
              },
              {
                value: isDayViewMode ? this.state.selectedAssayFilter : '',
                key: 'selectedAssay',
                type: 'string',
              },
            ],
            this.props.querySearchParams,
            this.props.setQuerySearchParams
          );
        });

        break;
      }
      case 'selectedAssayFilter': {
        const newValue = this.state.assayFilter[index];
        this.setState({ selectedAssayFilter: newValue }, () => {
          setQueryParam(
            [
              {
                value: this.state.selectedAssayFilter,
                key: 'selectedAssay',
                type: 'string',
              },
            ],
            this.props.querySearchParams,
            this.props.setQuerySearchParams
          );
        });
        break;
      }
      default:
        break;
    }
  };

  _populateAssayFilter = (assayList) => {
    let assayArr = ['All assays'];

    assayList.forEach((e) => {
      let tempArr = e.split(',');
      tempArr.forEach((tempEl) => {
        if (!assayArr.includes(tempEl) && tempEl !== '') {
          assayArr.push(tempEl);
        }
      });
    });

    this.setState({ assayFilter: assayArr });
  };

  _getTableData = (responseData, selectedReport) => {
    var tableData = responseData;
    if (this.state.selectedViewModeFilter.name === 'by assay') {
      var sortedTableData = tableData.sort(function (a, b) {
        return a.Assays.localeCompare(b.Assays);
      });

      //remove rows that are not relevant for other categories
      sortedTableData = sortedTableData.filter(function (el, i) {
        return el.Assays !== '';
      });

      return sortedTableData;
    } else {
      return tableData;
    }
  };

  _onApplyFilters = () => {
    if (!this.state.selectedEventCategoryFilter) {
      this.setState({ isFetching: false });
    } else {
      this.setState({ isFetching: true });
      const serialNumber = this.props.instrument.SerialNumber;
      const start = Utils.FeDateAsUtcForBeISOString(this.state.dateFromFilter);
      const end = Utils.FeDateAsUtcForBeISOString(this.state.dateToFilter);
      const selectAllPerDay =
        this.state.selectedAssayFilter === '' || this.state.selectedAssayFilter === 'All assays'
          ? 'true'
          : '';
      const selectedAssay = this.state.selectedAssayFilter;
      const selectedReport =
        this.state.selectedViewModeFilter.name === 'by day'
          ? this.state.selectedEventCategoryFilter.reportByDay
          : this.state.selectedEventCategoryFilter.reportByAssay;

      getEventStatisticsData(
        serialNumber,
        selectedReport,
        start,
        end,
        selectAllPerDay,
        selectedAssay
      )
        .then((res) => {
          const data = res.body;
          const tbl = data.find((el) => el.Name === 'Table');

          const assayData = Array.from(tbl.Data, (el) => el.Assays);

          this._populateAssayFilter(assayData);

          this.setState({
            tableData: this._getTableData(tbl.Data, selectedReport),
            tableConfig: tbl.Configuration.columnsConfig,
            isFetching: false,
            metadata: data.find((el) => el.Name === 'Metadata').Data.EventStatisticData,
          });
        })
        .catch((e) =>
          this.setState({
            isFetching: false,
          })
        );
    }
  };

  _checkDateTimeCorrectness = (dateFrom, dateTo) => {
    let dateTimeErrorMessage;
    if (moment(dateFrom).isAfter(dateTo)) {
      dateTimeErrorMessage = Constants.DATEFROM_AFTER_DATETO_ERROR_MESSAGE;
    }

    if (moment(dateTo).isBefore(dateFrom)) {
      dateTimeErrorMessage = Constants.DATETO_BEFORE_DATEFROM_ERROR_MESSAGE;
    }

    return dateTimeErrorMessage;
  };
}

export default withRouter(EventStatisticsContainer);
